import { ClientType } from '@common/model/client/clientType';
import { DealStatus } from '@common/model/deal';
import { Skeleton } from '@cp/ds/src/components/skeleton';
import { Typography } from '@cp/ds/src/components/typography';
import { useTheme } from '@cp/ds/src/hooks';
import { adminProcessingApi } from 'src/entities/processing';

interface StatisticsViewProps {
  clientType: ClientType;
  participantId: number;
  status: DealStatus;
}

const getLabel = (status: DealStatus) => {
  switch (status) {
    case DealStatus.Rejected:
      return 'Отказов';
    case DealStatus.Completed:
      return 'Оценено';
    default:
      return null;
  }
};

export const StatisticsView = (props: StatisticsViewProps) => {
  const { palette } = useTheme();
  const label = getLabel(props.status);
  const stat = adminProcessingApi.endpoints.getProcessingStatistics.useQuery(props, { skip: !label });

  if (stat.isLoading) {
    return <Skeleton height={20} width={90} />;
  }

  if (!label || !stat.data?.percentage) return null;

  return (
    <Typography
      sx={{ color: palette['brand pink hover'] }}
      variant="small text bold"
    >{`${label}: ${stat.data.percentage * 100}%`}</Typography>
  );
};
